import { useEffect } from 'react';
import { IS_CURRENT_BROWSER_FIREFOX } from '../../Vector/mfrchart/constants';

const useBrowserSpecificExceptions = () => {
  useEffect(() => {
    if (IS_CURRENT_BROWSER_FIREFOX) {
      const bodyElements = document.getElementsByTagName('body')[0];
      bodyElements.classList.add('mozilla-scrollbar');
    }
  }, []);
};

export default useBrowserSpecificExceptions;
